/**
 * @module services/health-conversation
 * @description Read-only de transcript completo de una HealthConversation.
 *              No tiene CRUD: la conversation se crea/avanza solo desde el
 *              dispatcher + webhook handler de la API.
 */
import api from "./api";

const healthConversationService = {
  /**
   * @description Devuelve la conversation completa con turnos + status.
   *              Usado por HealthConversationResultDetail.vue.
   * @param {string} id
   * @returns {Promise<Object>} { turns, status, lastInteractionAt, ... }
   */
  get(id) {
    return api.get(`/health-conversations/${id}`);
  },
};

export default healthConversationService;
